import HomePageFooterSidebar from './HomePageFooterSidebar';

export default HomePageFooterSidebar;
